import React from "react";

import { useIntl } from "react-intl";

import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";

import MultiSelectActivityTypeField from "@app/component/input/MultiSelectActivityTypeField";

import styles from "./FormItems.module.scss";

interface Props {
  onChange?: (value: ActivityType["id"][]) => void;
  value?: ActivityType["id"][];
}

const NearbyRecordSuggestion: React.FC<Props> = ({ onChange, value }) => {
  const intl = useIntl();

  return (
    <div className={styles.formItemContainer}>
      <p className={styles.fieldTitle}>
        {intl.formatMessage({
          id: "settings.organizationDetails.nearbyRecordSuggestions.label",
          defaultMessage:
            "Show “Nearby record” suggestions on Smart Planner for the following types:",
          description: "Nearby Record suggestions label of settings organization details",
        })}
      </p>
      <MultiSelectActivityTypeField
        allowClear
        onChange={onChange}
        placeholder={intl.formatMessage({
          id: "settings.organizationDetails.nearbyRecordSuggestions.placeholder",
          defaultMessage: "All types",
          description: "All types option for nearby Record Suggestions",
        })}
        size="large"
        value={value}
      />
    </div>
  );
};

export default NearbyRecordSuggestion;
